'use client';
import { useSearchParams } from 'next/navigation';
import { validate } from '../../../../../schema/input/entry.js';
/**
 * React hook which sanitize and validate query parameters.
 * If invalid, undefined will be returned.
 *
 * @param parameter parameters to validate
 * @returns typed query parameters object
 */
export function useSearchParameters(...parameter) {
    const search = useSearchParams();
    const paramObj = parameter.reduce((params, param) => ({ ...params, [param]: search.get(param) }), {});
    return validate.query(...parameter).parse(paramObj) ?? {};
}
//# sourceMappingURL=useSearchParameters.js.map